module.exports = __webpack_public_path__ + "img/2.27159007.png";